import {clsx} from "clsx";
import {twMerge} from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const getFilePath = (fileName)  => {
  return `${import.meta.env.VITE_MEDIAS_BASE_URL}/${fileName}`;
};
